import { Box, Button as ThemeUiButton } from "theme-ui";

import { ChevronLeftIcon, ChevronRightIcon } from "components/icons";
import * as styles from "./ReviewImages.styles";

export default function ReviewImages({
  selectedImageViewAngle,
  setSelectedImageViewAngle,
  imageAngles = [],
  images: imageSets = [{ imageSet: "DEFAULT", images: [] }],
}) {
  const isMultipleImageAngles = imageAngles.length > 1;

  return (
    <Box sx={styles.reviewImages}>
      {isMultipleImageAngles && (
        <>
          <ThemeUiButton
            variant="unstyled"
            aria-label="previous"
            onClick={() => {
              setSelectedImageViewAngle(
                (selectedImageViewAngle + imageAngles.length - 1) %
                  imageAngles.length
              );
            }}
            sx={styles.previousButton}
          >
            <ChevronLeftIcon />
          </ThemeUiButton>

          <ThemeUiButton
            variant="unstyled"
            aria-label="next"
            onClick={() => {
              setSelectedImageViewAngle(
                (selectedImageViewAngle + 1) % imageAngles.length
              );
            }}
            sx={styles.nextButton}
          >
            <ChevronRightIcon />
          </ThemeUiButton>
        </>
      )}

      <Box>
        {imageSets.map(({ imageSet, images }) => (
          <Box key={imageSet} sx={styles.imageContainer}>
            {images.map(({ name, url }, zIndex) => (
              <Box
                key={name}
                className={`product-image--${name}`}
                style={{ backgroundImage: `url(${url})`, zIndex }}
              />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
